import React from 'react';
import UploadModal from './../../../common/UploadModal'
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/routing/sms/master`,
            data: {
                data: [],
                metadata: []
            },
            loading: false,
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSMSMASTERCODEID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Destnation Code',
                        'source': 'ATRDESTCODE',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': '123'
                    },
                    {
                        'label': 'Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Destination'
                    },
                    {
                        'label': 'Country code',
                        'source': 'ATRISOCOUNTRY',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'US'
                    },
                    {
                        'label': 'MCC',
                        'source': 'ATRMCC',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': '000'
                    },
                    {
                        'label': 'MNC',
                        'source': 'ATRMNC',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': '00'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "SMS Master Code List" options = {<Upload {...this.props}/>}>
                <Resource
                    addButtonText = "Add New Code"                    
                    data = {data}
                    {...this.props} 
                    pagination
                />
            </Panel>
        )
    }
}


class Upload extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            refetch: 0
        }
    }
    onUploadRequest() {
        this.setState({ modalIsOpen: true})
    }
    onHide() {
        this.setState({ modalIsOpen: false})
    }
    onUploadSuccess() {
        this.setState({
            refetch: Math.random(),
            modalIsOpen: false
        });

    }
    render() {
        return(
            <div>
                <UploadModal
                    modalIsOpen = {this.state.modalIsOpen}
                    onHide = {this.onHide.bind(this)}
                    onUploadSuccess = { this.onUploadSuccess.bind(this) }
                    modalTitle = "Upload Master List"
                    url_upload = "/admin/routing/sms/master/upload"
                    url_confirm = "/admin/routing/sms/master/confirm"
                    url_progress = "/admin/routing/sms/master/progress"
                    childProps = {this.props.childProps }
                />
                <button onClick={this.onUploadRequest.bind(this)} className="btn btn-upload">Upload Master List</button>
            </div>)
    }
}

